import { render, staticRenderFns } from "./PeopleInput.vue?vue&type=template&id=12e41717&scoped=true"
import script from "./PeopleInput.vue?vue&type=script&lang=js"
export * from "./PeopleInput.vue?vue&type=script&lang=js"
import style0 from "./PeopleInput.vue?vue&type=style&index=0&id=12e41717&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e41717",
  null
  
)

export default component.exports